import LegalLayout from "@/pages/LegalLayout";

export default function Widerruf() {
  return (
    <LegalLayout title="Widerrufs­belehrung">
      <h2>Widerrufsrecht für Verbraucher</h2>
      <p>
        <em>Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können.</em>
      </p>
      <p>
        Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsabschlusses.
      </p>
      <p>
        Um Ihr Widerrufsrecht auszuüben, müssen Sie mich (Reputationsmanagement, Petra Osterode, Dubliner Str. 17, 30982 Pattensen, Telefon: +49 172 5263514, E-Mail: <a href="mailto:info@femmesmarketing.com">info@femmesmarketing.com</a>) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
      </p>
      <p>
        Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
      </p>

      <h2>Folgen des Widerrufs</h2>
      <p>
        Wenn Sie diesen Vertrag widerrufen, habe ich Ihnen alle Zahlungen, die ich von Ihnen erhalten habe, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von mir angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei mir eingegangen ist. Für diese Rückzahlung verwende ich dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
      </p>
      <p>
        Haben Sie verlangt, dass die Dienstleistung während der Widerrufsfrist beginnen soll, so haben Sie mir einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie mich von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht.
      </p>

      <h2>Muster-Widerrufsformular</h2>
      <p>Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.</p>
      <p>
        An<br />
        Reputationsmanagement<br />
        Petra Osterode<br />
        Dubliner Str. 17<br />
        30982 Pattensen<br />
        E-Mail: info@femmesmarketing.com
      </p>
      <p>
        Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über die Erbringung der folgenden Dienstleistung (Bezeichnung, ggf. Bestellnummer und Preis):
      </p>
      <p>
        ..............................................................................<br />
        ..............................................................................
      </p>
      <p>Bestellt am (Datum): .............................</p>
      <p>Erhalten am (Datum): .............................</p>
      <p>
        Name und Anschrift des Verbrauchers:<br />
        .............................<br />
        .............................<br />
        .............................<br />
        .............................
      </p>
      <p>Datum: ....................................................</p>
      <p>Unterschrift Kunde (nur bei schriftlichem Widerruf): ....................................................</p>

      <h2>Hinweis zum Kundenkreis</h2>
      <p>
        Dieses Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB. Verbraucher im Sinne des § 13 BGB sind von der Nutzung der angebotenen Dienstleistungen ausgeschlossen.
      </p>
      <p>
        Sollte in Einzelfällen dennoch ein Vertrag mit einem Verbraucher zustande kommen, beginnt die Ausführung der Dienstleistung unmittelbar nach Bestellung. Mit Beginn der Ausführung der Dienstleistung kann ein eventuell bestehendes Widerrufsrecht gemäß § 356 Abs. 4 BGB vorzeitig erlöschen.
      </p>
    </LegalLayout>
  );
}
